import { ReactNode } from 'react';
import { cn } from '../util';
import { Heading } from './Heading';

interface TileProps {
  title: string;
  titleSize?: 'xsm' | 'sm' | 'm' | 'l';
  actions?: ReactNode;
  children: ReactNode;
  className?: string;
}

export const Tile = ({ title, titleSize, actions, children, className }: TileProps) => {
  return (
    <div
      className={cn(
        'bg-primary border-highlight flex h-full flex-col justify-between rounded-[20px] border p-5 brightness-110',
        className
      )}
    >
      <div className="flex justify-between">
        <Heading size={titleSize || 'm'}>{title}</Heading>
        {actions && <div>{actions}</div>}
      </div>

      <div className="overflow-y-auto">{children}</div>
    </div>
  );
};
